import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LocalStorageService } from 'angular-web-storage';
import { CaseLog, CaseLogDirection, CaseLogResourceType } from '../../_types/case-log';
import { Integration } from 'src/app/modules/companies/_types/integration';
import { IntegrationsService } from 'src/app/modules/companies/_services/integrations.service';
import { IntegrationEventsService } from 'src/app/modules/companies/_services/integration-events.service';
import { IntegrationEvent } from 'src/app/modules/companies/_types/integration-event';
import { CasesLogsService } from '../../_services/cases-logs.service';
import { CaseLogType } from '../../_types/case-log-type';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { CaseLogTypesService } from '../../_services/cases-log-types.service';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { ContractCaseLogType } from 'src/app/modules/companies/_types/contract-case-log-type';
import { ContractCaseLogsTypesService } from 'src/app/modules/companies/_services/contracts-case-logs-types.service';
import { ContractsService } from 'src/app/modules/companies/_services/contracts.service';
import { Contract } from 'src/app/modules/companies/_types/contract';
import { GeneraliService } from 'src/app/modules/companies/_services/generali.service';
import { CasesFilesService } from '../../_services/cases-files.service';
import { CaseFile } from '../../_types/case-file';
import { CasesServicesService } from '../../_services/cases-services.service';
import { CaseService } from '../../_types/case-service';
import { environment } from 'src/environment/environment';
import { name } from 'sip.js';
import { File } from 'src/app/modules/common/_types/file';
import { FilesService } from 'src/app/modules/common/_services/files.service';
import { CaseNotificationNumber } from '../../_types/case-notification-number';
import { CasesNotificationsNumbersService } from '../../_services/cases-notifications-numbers.service';
import { TemplatesService } from 'src/app/modules/templates/_services/templates.service';
import { Template } from 'src/app/modules/templates/_types/template';
import { CasesService } from '../../_services/cases.service';
import { formatDate } from '@angular/common';
import { ClientsService } from 'src/app/modules/clients/_services/clients.service';
import { AffectedsService } from '../../_services/affecteds.service';
import { DynamicFieldsContext, DynamicFieldsService } from 'src/app/core/services/dynamic-fields.service';

@Component({
    selector: 'app-case-log-detail',
    templateUrl: './case-log-detail.component.html',
    styleUrls: ['./case-log-detail.component.scss'],
    standalone: false
})
export class CaseLogDetailComponent {
  public caseLogGroup!: RxFormGroup;
  public caseId: string = '';
  public contractId: string = '';
  public caseLogTypes: CaseLogType[] = [];

  public eventData: CaseLog = new CaseLog();
  //public eventData: CaseLog;
  public Integration: Integration | null = null;
  public integration?:Integration;
  public integrationConfiguration?:any;
  public integrationEventData?:any;
  public caseNotificationNumbers: CaseNotificationNumber[] = [];
  public templateSearch:string = '';
  public templatesCaseLogs: Template[] = [];
  public messageMaxLength: number | null = null;

  //selector de ficheros
  public imagesUrl: string = environment.api_gw + 'common/files/';
  public selectFilesVisible: boolean = false;
  public caseServices: any[] = [];
  public caseFiles: any[] = [];
  public caseFilesServices: any[] = [];
  public caseFilesWithoutService: any[] = [];
  public selectedFiles:  any[] = [];
  public selectedFileTypes: any[] = []; //solo para que no marque opcion

  //personas, en principio solo lo requiere mutua madrileña
  //deberia ser el asegurado y ¿los afectados?
  public persons: any[] = [];

  public generali:any = {
    situationOptions: {}
  };
  public items: MenuItem[] = [];

  //integraciones cuyo formulario NO se renderiza desde eventForm (mantienen su bloque propio)
  private nonDynamicIntegrationCodes: string[] = ['GENERALI'];

  //formulario propio del tipo de evento (CaseLogType/ContractCaseLogType.fieldsConfiguration)
  public typeFields: any[] = [];
  public typeFieldsData: any = {};
  //override de formulario por tipo definido en el contrato, indexado por caseLogTypeId
  private contractFieldsByTypeId: { [caseLogTypeId: string]: string | null } = {};
  public serviceId: string | null = null;

  constructor(
    private integrationsService: IntegrationsService,
    private integrationEventsService: IntegrationEventsService,
    private caseLogTypesService: CaseLogTypesService,
    private contractCaseLogsTypesService: ContractCaseLogsTypesService,
    private casesLogsService: CasesLogsService,
    private casesService:CasesService,
    private contractService: ContractsService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private formBuilder: RxFormBuilder,
    private generaliService: GeneraliService,
    private casesFilesService: CasesFilesService,
    private casesServicesService: CasesServicesService,
    private filesService: FilesService,
    private caseNotificationsNumbersService: CasesNotificationsNumbersService,
    private templatesService: TemplatesService,
    private clientsService: ClientsService,
    private affectedsService: AffectedsService,
    private dynamicFieldsService: DynamicFieldsService
  ) {
    this.caseLogGroup = this.formBuilder.formGroup<CaseLog>(this.eventData) as RxFormGroup;
  }

  async ngOnInit() {
   

    this.caseId = this.config.data.caseId;
    this.contractId = this.config.data.contractId;
    await this.loadContractCaseLogTypes();

    this.loadCaseNotificationsNumbers();

    this.loadCasePersons();

    //preparamos datos de nuevo caseLog
    this.eventData = new CaseLog();
    this.eventData.caseId = this.caseId;
    this.eventData.date = new Date();
    this.eventData.direction = CaseLogDirection.Out;
    this.eventData.resourceType = CaseLogResourceType.Manual;
    this.eventData.caseLogTypeId = "";
    this.eventData.message = "";

    //cargamos la integración del contrato si tiene
    this.integrationEventData = {};
    await this.loadIntegration();

    //Cargmos las opciones de Seleccinar todas las imagesne.
    if(this.isDynamicIntegration){
      let fileTypes = this.integrationConfiguration?.eventForm?.fileTypes ?? [];
      this.items = fileTypes.map((fileType:any) => ({
        label: fileType.text ?? fileType.label,
        type: fileType.value,
        command: (event: any) => {
          this.selectAll(event.item.type, this.serviceId!);
        }
      }));
    }else if(this.integration?.code == "GENERALI"){
      this.generali.situationOptions?.documentTypes?.forEach((element:any) => {
          this.items.push(
            {
                label: element.text,
                type: element.type,
                command: (event: any) => {
                    this.selectAll(event.item.type, this.serviceId!);
                }
            }
          )
      });
    }

    //cargamos tipo de plantilla
    this.loadTemplateCaseLogs();
  }

  async loadCasePersons() {
    //cargamos el expediente
    let caseData = await firstValueFrom(this.casesService.get(this.caseId));

    let n = 0;
    this.persons = [];

    //cargamos el cliente
    if(caseData.clientId){
      let client = await firstValueFrom(this.clientsService.get(caseData.clientId!));
      let option = {
        label: client.name,
        value: n
      };
      n++;
      this.persons.push(option);
    }

    //cargamos los afectados
    let filter : any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.caseId)
    };
    let params:IParamsCollection = {
      page: { size: 50 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.affectedsService.all(params));
    response.data.forEach(affected => {
      let option = {
        label: affected.name,
        value: n
      };
      n++;
      this.persons.push(option);
    });
  }

  async loadCaseNotificationsNumbers() {
    let filter : any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.caseId)
    };
    let params:IParamsCollection = {
      page: { size: 50 },
      sort: ['date'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.caseNotificationsNumbersService.all(params));
    this.caseNotificationNumbers = response.data;
  }
  
  async loadContractCaseLogTypes(){

    let availbaleCaseLogTypes: CaseLogType[] = [];

    //los genericos
    let filters = {
      isGeneric: new Filter(FilterOperation.equals, 'isGeneric', "", true)
    };
    let params: IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.caseLogTypesService.all(params));
    availbaleCaseLogTypes = response.data;
    
    //los del contrato
    let filtersContract = {
      contractId: new Filter(FilterOperation.equals, 'contractId', "", this.contractId)
    };
    let paramsContract: IParamsCollection = {
      filter: FilterBuilder.fromObject(filtersContract).build(),
      sort: ['caseLogType.name'],
      include: ['caseLogType']
    };
    let contractResponse = await firstValueFrom(this.contractCaseLogsTypesService.all(paramsContract));

    //añadimos los del contrato, salvo que ya estén incluidos, y guardamos su formulario propio
    contractResponse.data.forEach((contractCaseLogType: ContractCaseLogType) => {
      if(!availbaleCaseLogTypes.some((caseLogType: CaseLogType) => caseLogType.id == contractCaseLogType.caseLogTypeId)){
        availbaleCaseLogTypes.push(contractCaseLogType.caseLogType);
      }
      if(contractCaseLogType.caseLogTypeId){
        this.contractFieldsByTypeId[contractCaseLogType.caseLogTypeId] = contractCaseLogType.fieldsConfiguration ?? null;
      }
    });

    //si está el caseLogType de empresa, lo ponemos primero
    let companyCaseLogType = availbaleCaseLogTypes.find((caseLogType: CaseLogType) => caseLogType.code == 'COMPANY');
    if(companyCaseLogType){
      availbaleCaseLogTypes = availbaleCaseLogTypes.filter((caseLogType: CaseLogType) => caseLogType.code != 'COMPANY');
      availbaleCaseLogTypes.unshift(companyCaseLogType);
    }

    this.caseLogTypes = availbaleCaseLogTypes;
  }

  async loadIntegration() {
    let contract:Contract = await firstValueFrom(this.contractService.get(this.contractId));
    if(contract.integrationId!=null){
      this.integration = await firstValueFrom(this.integrationsService.get(contract.integrationId));
      if(this.integration && this.integration.configuration){
        this.integrationConfiguration = JSON.parse(this.integration.configuration);

        if(this.integration.code == 'GENERALI'){
          let oCase = await firstValueFrom(this.casesService.get(this.caseId));
          if(oCase.notificationNumber!=null && oCase.notificationNumber!=''){
            this.loadGeneraliSituationOptions();
            this.loadGeneraliNewDialogOptions();
            this.loadGeneraliDialogs();
          }else{
            //quitamos la opción de compañia porque requiere casenumber
            this.caseLogTypes = this.caseLogTypes.filter((caseLogType: CaseLogType) => caseLogType.code != 'COMPANY');
          }
        }
      }
    }
  }

  isCompanyCaseLogType(caseLogTypeId: string|undefined){
    let caseLogType = this.caseLogTypes.find((caseLogType: any) => caseLogType.id == caseLogTypeId && caseLogType.code == 'COMPANY');
    return caseLogType!=null;
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  async loadTemplateCaseLogs() {
    let filter:any = {
      templateType: new Filter(FilterOperation.equals, "templateType", '', "CaseLog")
    };
    let params: IParamsCollection = {
      page: { size: 100 },
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.templatesService.all(params));
    this.templatesCaseLogs = response.data;
  }

  getFilteredTemplatesCaseLogs():Template[] {
    return this.templatesCaseLogs.filter((template: Template) => {
      return template.name.toLowerCase().includes(this.templateSearch.toLowerCase()) || this.templateSearch == '';
    });
  }

  /* formularios dinámicos (ver DynamicFieldsService) */

  //contexto con el que se resuelven las opciones de los campos
  get dynamicContext(): DynamicFieldsContext {
    return {
      configuration: this.integrationConfiguration,
      persons: this.persons,
      notificationNumbers: this.caseNotificationNumbers
    };
  }

  //true si la integración se renderiza desde la configuración eventForm
  get isDynamicIntegration(): boolean {
    return this.integration != null && !this.nonDynamicIntegrationCodes.includes(this.integration.code);
  }

  //campos del formulario de la integración (vacío si la integración no es dinámica o no tiene eventForm)
  get integrationFields(): any[] {
    if(!this.isDynamicIntegration) return [];
    return this.integrationConfiguration?.eventForm?.fields ?? [];
  }

  //campos a validar como requeridos: para integraciones dinámicas, los de eventForm; para GENERALI
  //(formulario hardcodeado) los que ahora mismo son visibles-y-required, calculados en código
  get integrationValidationFields(): any[] {
    if(this.isDynamicIntegration) return this.integrationFields;
    if(this.integration?.code == 'GENERALI') return this.buildGeneraliRequiredFields();
    return [];
  }

  //el formulario de la integración solo aplica al tipo de evento de compañía
  get showIntegrationFields(): boolean {
    return this.integrationFields.length > 0
      && this.integrationConfiguration != null
      && this.isCompanyCaseLogType(this.eventData?.caseLogTypeId);
  }

  /**
   * Al cambiar el tipo de evento resolvemos su formulario propio: manda el del contrato
   * (ContractCaseLogType.fieldsConfiguration) cuando tiene contenido y, si no, el del tipo.
   * Las respuestas se reinician porque pertenecen al tipo anterior.
   */
  onCaseLogTypeChange(){
    let caseLogTypeId = this.eventData?.caseLogTypeId;
    this.messageMaxLength = this.integration?.code == 'GENERALI' && this.isCompanyCaseLogType(caseLogTypeId) ? 400 : null;
    let configuration = caseLogTypeId ? this.contractFieldsByTypeId[caseLogTypeId] : null;
    if(configuration == null || configuration.trim() == ''){
      let caseLogType = this.caseLogTypes.find((m: CaseLogType) => m.id == caseLogTypeId);
      configuration = caseLogType?.fieldsConfiguration ?? null;
    }
    this.typeFields = this.dynamicFieldsService.parseFields(configuration);
    this.typeFieldsData = {};
    this.dynamicFieldsService.applyChange(this.typeFields, null, this.typeFieldsData, this.dynamicContext);
  }

  /* fin formularios dinámicos */

  /**
   * El mensaje solo es obligatorio cuando el tipo de evento no trae formulario propio: si lo trae, las
   * respuestas ya describen el evento y el resumen se antepone al mensaje, así que escribir texto libre
   * encima es opcional.
   */
  get isMessageRequired(): boolean {
    return this.typeFields.length == 0;
  }

  async save() {
    let hasMessage = this.eventData?.message != null && this.eventData.message != "";
    if(this.eventData != null && (hasMessage || !this.isMessageRequired) && this.eventData.caseLogTypeId!=null  && this.eventData.caseLogTypeId!=""){

      if(this.messageMaxLength != null && (this.eventData.message?.length ?? 0) > this.messageMaxLength){
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'El mensaje a Generali no puede superar los ' + this.messageMaxLength + ' caracteres' });
        return;
      }

      //validamos el formulario propio del tipo de evento
      let missingTypeField = this.dynamicFieldsService.getFirstMissingRequired(this.typeFields, this.typeFieldsData);
      if(missingTypeField != null){
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe rellenar el campo: ' + missingTypeField });
        return;
      }

      //validamos los campos requeridos visibles de la integración (dinámica o GENERALI)
      if(this.integration && this.isCompanyCaseLogType(this.eventData.caseLogTypeId)){
        let missingIntegrationField = this.dynamicFieldsService.getFirstMissingRequired(this.integrationValidationFields, this.integrationEventData);
        if(missingIntegrationField != null){
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe rellenar el campo: ' + missingIntegrationField });
          return;
        }
      }

      //respuestas del formulario del tipo: resumen antepuesto al mensaje y guardadas en la metainformación.
      //A diferencia de la integración, aquí se hace antes de guardar porque no depende del id del evento.
      if(this.typeFields.length > 0){
        //el mensaje puede venir vacío: el resumen de las respuestas es entonces todo el contenido, y en
        //ese caso se quita el <br> de separación con el que el resumen termina para no dejar una línea suelta
        let summary = this.dynamicFieldsService.buildSummary(this.typeFields, this.typeFieldsData, this.dynamicContext);
        if(!hasMessage) summary = summary.replace(/(<br>)+$/, '');
        this.eventData.message = summary + (this.eventData.message ?? '');
        this.eventData.caseLogMetadata = { ...(this.eventData.caseLogMetadata ?? {}), fields: this.typeFieldsData };
      }

      var caseLogSave = await firstValueFrom(this.casesLogsService.save(this.eventData));

      //si tiene integración, guardamos el evento
      if(this.integration && this.isCompanyCaseLogType(this.eventData.caseLogTypeId)){
        this.integrationEventData.content = caseLogSave.message;
        let integrationEvent = new IntegrationEvent();
        integrationEvent.integrationId = this.integration.id!;
        integrationEvent.data = JSON.stringify(this.integrationEventData);
        integrationEvent.sourceId = caseLogSave.id!;
        var integrationEventSave = await firstValueFrom(this.integrationEventsService.save(integrationEvent));

        //GENERALI conserva su lógica propia; el resto usa el resumen genérico de eventForm
        if(this.integration.code == 'GENERALI'){
          let preMessage = '';
          let communicationType = this.integrationConfiguration.communicationTypes.find((m:any)=>m.value == this.integrationEventData.communicationId);
          if(communicationType.value=='NEW_SITUATION'){
            let situationOption = this.generali.situationOptions.situationOptions.find((m:any)=>m.value == this.integrationEventData.situationId);
            let destinatary = this.generali.situationOptions.destinataryList.find((m:any)=>m.value == this.integrationEventData.destinataryId);
            preMessage = "<b>" + communicationType.label + " con asunto " + situationOption?.text + " y destinatario " + destinatary?.text  + "</b><br>";

            //si tiene fecha prevista, la añadimos al mensaje
            if(this.integrationEventData.previsionDate) preMessage += "Fecha prevista: " + this.integrationEventData.previsionDate.toLocaleDateString() + "<br>";

            //si tiene fecha de acción futura, la añadimos al mensaje
            if(this.integrationEventData.futureActionDate) preMessage += "Fecha de acción futura: " + this.integrationEventData.futureActionDate.toLocaleDateString() + "<br>";

            //si tiene descripción de accion futura, la añadimos al mensaje
            if(this.integrationEventData.futureActionDescription) preMessage += "Descripción de acción futura: " + this.integrationEventData.futureActionDescription + "<br>";

            //si tiene revisión, la añadimos al mensaje
            if(this.integrationEventData.answerRequired) preMessage += "Requiere respuesta: Sí<br>";
            else preMessage += "Requiere respuesta: No<br>";

            //si contiene adjuntos
            if(this.integrationEventData.files && this.integrationEventData.files.length > 0) preMessage += "Adjuntos: Sí<br>";

          }else if(communicationType.value=='NEW_DIALOG' || communicationType.value=='RESPONSE_DIALOG'){
            let subjectOption = this.generali.newDialogOptions.subjectOptions.find((m:any)=>m.value == this.integrationEventData.subjectId);
            let destinatary = this.generali.newDialogOptions.destinataryOptions.find((m:any)=>m.value == this.integrationEventData.destinataryId);
            preMessage = "<b>" + communicationType.label + " con asunto " + subjectOption?.text + " y destinatario " + destinatary?.text  + "</b><br>";

            //si tiene revisión, la añadimos al mensaje
            if(this.integrationEventData.answerRequired) preMessage += "Requiere respuesta: Sí<br>";
            else preMessage += "Requiere respuesta: No<br>";

            //si contiene adjuntos
            if(this.integrationEventData.files && this.integrationEventData.files.length > 0) preMessage += "Adjuntos: Sí<br>";

          }else if(communicationType.value=='TECHNICAL_CALL_REQUEST'){
            preMessage = "<b>" + communicationType.label + "</b><br>";
            if(this.integrationEventData.phone) preMessage += "Teléfono: " + this.integrationEventData.phone + "<br>";

            //si contiene adjuntos
            if(this.integrationEventData.files && this.integrationEventData.files.length > 0) preMessage += "Adjuntos: Sí<br>";
            
          }

          //añadimos el mensaje previo al mensaje del caseLog
          if(preMessage != '') preMessage += "<br>";
          caseLogSave.message = preMessage + caseLogSave.message;
        }else{
          //resto de integraciones: resumen genérico construido desde eventForm
          caseLogSave.message = this.dynamicFieldsService.buildSummary(this.integrationFields, this.integrationEventData, this.dynamicContext) + caseLogSave.message;
        }

        //actualizamos el caseLog con el id del evento
        caseLogSave.integrationEventId = integrationEventSave.id;
        caseLogSave = await firstValueFrom(this.casesLogsService.save(caseLogSave));
      }
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Comunicación guardada correctamente." });
      this.dynamicDialogRef.close(caseLogSave);
    }else{
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe rellenar todos los campos' });
    }
  }

  /* generali */
  async loadGeneraliSituationOptions() {
    let situationOptions = await firstValueFrom(this.generaliService.GetSituationOptions(this.caseId));
    this.generali.situationOptions = situationOptions;
  }
  async loadGeneraliNewDialogOptions() {
    let newDialogOptions = await firstValueFrom(this.generaliService.GetNewDialogOptions(this.caseId));
    this.generali.newDialogOptions = newDialogOptions;
  }
  async loadGeneraliDialogs() {
    let dialogs = await firstValueFrom(this.generaliService.GetDialogs(this.caseId));
    dialogs.forEach((dialog:any) => {
      if(dialog.subject=='' && dialog.messages && dialog.messages.length > 0) {
        dialog.subject = dialog.messages[0].text;
      }
    });
    //los ordenamos por fecha de último mensaje
    dialogs = dialogs.sort((a:any, b:any) => {
      if(a.lastMessageDate < b.lastMessageDate) return 1;
      if(a.lastMessageDate > b.lastMessageDate) return -1;
      return 0;
    });
    this.generali.dialogs = dialogs;
  }
  getGeneraliSituation(value:string){
    return this.generali.situationOptions?.situationOptions?.find((option:any) => option.value == value);
  }

  /**
   * Espejo de los [required] del formulario hardcodeado de GENERALI (ver plantilla): devuelve, según
   * el tipo de comunicación y los flags de la situación cargada, los campos obligatorios en este momento.
   * MANTENER SINCRONIZADO con los *ngIf/[required] de case-log-detail.component.html.
   */
  private buildGeneraliRequiredFields(): any[] {
    let data = this.integrationEventData;
    let fields: any[] = [];
    let communicationId = data?.communicationId;
    if(communicationId == 'NEW_DIALOG' || communicationId == 'RESPONSE_DIALOG'){
      fields.push({ code: 'subjectId', label: 'Asunto', required: true });
      if(communicationId == 'RESPONSE_DIALOG') fields.push({ code: 'dialogId', label: 'Dialogo', required: true });
      fields.push({ code: 'destinataryId', label: 'Destinatario', required: true });
    }else if(communicationId == 'NEW_SITUATION'){
      fields.push({ code: 'situationId', label: 'Situación', required: true });
      fields.push({ code: 'destinataryId', label: 'Destinatario', required: true });
      let situation = this.getGeneraliSituation(data.situationId);
      if(situation?.guildRequired) fields.push({ code: 'guildId', label: 'Especialidad', required: true });
      if(situation?.previsionDateRequired) fields.push({ code: 'previsionDate', label: 'Fecha prevista', required: true });
      if(situation?.futureActionRequired) fields.push({ code: 'futureActionDate', label: 'Fecha de acción futura', required: true });
    }
    return fields;
  }
  async onGeneraliCommunicationTypeChange() {
  }
  /* end generali */

  async loadServices() {
      let params: IParamsCollection = {
        sort: ['date']
      }
      let filters: any = {
        caseId: new Filter(FilterOperation.equals, "caseId"),
      };
  
      filters.caseId.value = this.caseId;
      params.filter = FilterBuilder.fromObject(filters).build();
      params.include = ['worker'/*, 'equipment', 'capability', 'cancelCaseServiceReason', 'cancelCaseServiceCause'*/];
  
      let response = await firstValueFrom(this.casesServicesService.all(params));
      this.caseServices = response.data;
    }

  async loadCaseFiles() {
    let params: IParamsCollection = {
      include: ['file', 'caseFileCategory'],
      sort: ['-createdAt']
    }
    
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
      //caseFileCategoryId: new Filter(FilterOperation.equals, "caseFileCategoryId")
    };

    filters.caseId.value = this.caseId;

    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesFilesService.all(params));
    this.caseFiles = response.data;

    this.caseFilesServices = [];
    this.caseFilesWithoutService = [];
    this.caseFiles.forEach((caseFile: any) => {
       caseFile.selected = false; //para el selector
      if (caseFile.caseServiceId) {
        let caseService = this.caseServices.find((service: CaseService) => service.id == caseFile.caseServiceId);
        this.caseFilesServices.push({
          id: caseService?.id,
          name: (caseService?.worker?.name + " - " + caseService?.date.toLocaleString(
            'es-ES',
            {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            }
          ))
        });
      } else {
        this.caseFilesWithoutService.push(caseFile);
      }
    });

    // quitar duplicados
    this.caseFilesServices = this.caseFilesServices.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
  }

  filesByService(serviceId: string) {
    return this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == serviceId);
  }

  async showAddFiles() {
    await this.loadServices();
    await this.loadCaseFiles();
    this.selectFilesVisible = true;
    this.selectedFiles = [];
    this.selectedFileTypes = [];
  }

  async hideAddFiles() {
    this.selectFilesVisible = false;
    this.caseFiles = [];
    this.caseFilesServices = [];
    this.caseFilesWithoutService = [];
    this.selectedFiles = [];
    this.selectedFileTypes = [];
  }

  async onFileTypeChange($event:any, file:any){
    //buscamos si ya esta en lista para quitarlos o actualizar el tipo
    let selectedFile = this.selectedFiles.find((f:any) => f.id == file.fileId);
    if(selectedFile){
      //si ya está, actualizamos el tipo
      if($event.value == null || $event.value == undefined){
        this.selectedFiles = this.selectedFiles.filter((f:any) => f.id != file.fileId);
      }
      else {
        selectedFile.type = $event.value;
      }
     
    }else{
      this.selectedFiles.push({
        id: file.fileId,
        type: $event.value,
        name: file.file.fileName,
        category: file.caseFileCategory?.name
      });
    }
   
  }

  async addSelectedFiles() {
    this.integrationEventData.files = [];
    let index = 0;
    this.selectedFiles.forEach((fileData: any) => {
      this.integrationEventData.files.push(fileData);
      index++;
    });
    this.hideAddFiles();
  }

  async removeFile(file:any) {
    if(this.integrationEventData.files){
      this.integrationEventData.files = this.integrationEventData.files.filter((f:any) => f.id != file.id);
    }
  }

  async onSelectFile($event:any) {
    if($event.files && $event.files.length > 0){
      let file = $event.files[0];

      //creamos el file
      let data: File = new File();
      data.fileName = file.name;
      data.size = file.size;
      data.contentType = file.type; 
      let fileResponse = await firstValueFrom(this.filesService.save(data));  

      //asignamos el id del fichero al file
      this.integrationEventData.files = this.integrationEventData.files || [];
      this.integrationEventData.files.push({ id: fileResponse.id, name: fileResponse.fileName, type: '', category: '' });

      //subimos el fichero al file
      let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, file)); 
    }
  }

  async onClearFile($event:any){
    if(this.integrationEventData.files){
      //eliminamos los ya subidos
      this.integrationEventData.files.forEach((file:any) => {
        this.filesService.delete(file.id);
      });
      this.integrationEventData.files = [];
    }
  }

  selectAll($event:any, serviceId:string){
    this.selectedFiles = [];   
    if(serviceId != "" && serviceId != null){
      var filesservices =  this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == serviceId);
      filesservices.forEach((file: any) => {
        file.selected = $event;      
        this.onFileTypeChange({value:$event}, file);
      });
    }else{
      this.caseFilesWithoutService.forEach((caseFile: any) => {
        caseFile.selected = $event;
        this.onFileTypeChange({value:$event}, caseFile);
      });
    }
  }

}
